module.exports = __webpack_public_path__ + "media/partenaire/arrow_1-1d9ab2fe.png";